<template>
    <div>
        <Table :columns="columns" :data="data">
            <template slot-scope="{ row, index }" slot="num">
                {{row.num|numFilter(row)}}
            </template>
        </Table>
    </div>
</template>
<script>
  export default {
    name: 'classHourRecord',
    data() {
      return {
        columns: [
          {
            title: '说明',
            key: 'remark',
            align: 'left'
          },
          {
            title:'学员',
            key:'studentName'
          },
          {
            title:'校区',
            key:'zoneName'
          },
          {
            title: '课程',
            key: 'courseName',
            align: 'center'
          },
          {
            title: '课时',
            slot: 'num',
            align: 'center',
            width:100
          },
          {
            title: '剩余课时',
            key: 'after',
            align: 'center',
            width:100
          },
          {
            title: '时间',
            key: 'createtime',
            align: 'center'
          }
        ],
        data: []
      }
    },
    methods: {
      getList(){
        this.$api.student.getClassBuyRecordList({
          id:this.$route.query.id
        }).then(resp => {
          this.data = resp.data;
        });
      }
    },
    mounted() {
      this.getList();
    },
    filters: {
      numFilter: function (value,row) {
        if (row.type == 1){
          return " + " + value
        }else if (row.type == 2){
          return " - " + value
        }else{
          return "异常："+row.type+"|value";
        }
      },
    }
  }
</script>
